import { render, staticRenderFns } from "./quantitativeProtocol.vue?vue&type=template&id=b803b10e&scoped=true&"
import script from "./quantitativeProtocol.vue?vue&type=script&lang=js&"
export * from "./quantitativeProtocol.vue?vue&type=script&lang=js&"
import style0 from "./quantitativeProtocol.vue?vue&type=style&index=0&lang=less&"
import style1 from "./quantitativeProtocol.vue?vue&type=style&index=1&id=b803b10e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b803b10e",
  null
  
)

export default component.exports